import cn from 'classnames';
import type { CheckBoxColor } from '@/shared/types/icons';
import { CheckboxMark } from './CheckboxMark';

// Полностью controlled (vs оригинал mcms-front с внутренним useState — у того
// `checked` инициализирует state один раз, после чего prop игнорируется).
// Нужно для react-hook-form Controller-паттерна в ProfileForm: при reset()
// форма меняет prop, чекбокс должен отрисоваться по новому значению.

type CheckboxProps = {
  onChange?: (checked: boolean) => void;
  checked: boolean;
  label?: string;
  boxPosition?: 'left' | 'right';
  // Тот же union, что принимает сама галка (CheckboxMark → Icon). Раньше здесь
  // лежала копия списка без 'primary' — акцент темы нельзя было передать, и
  // формы прибивали цвет литералами ('blue' в кабинете, 'gray'/'black' по теме
  // на auth-страницах). Дефолт 'primary' резолвится в --action-primary: синий у
  // serious, зелёный у wapclick. Палитрные значения оставлены для
  // чекбоксов-легенд графика — там цвет означает серию, а не акцент.
  color?: CheckBoxColor;
  colorLabel?: string;
  className?: string;
  disabled?: boolean;
};

const CheckboxCommon: React.FC<CheckboxProps> = ({
  onChange,
  checked,
  label,
  boxPosition = 'left',
  color = 'primary',
  colorLabel = 'black',
  className,
  disabled = false,
}) => {
  const handleToggle = () => {
    if (disabled) return;
    onChange?.(!checked);
  };

  const wrapClasses = cn(
    'inline-flex cursor-pointer select-none items-center sm:text-nowrap',
    disabled ? 'opacity-50' : 'opacity-100',
    boxPosition === 'right' && 'flex-row-reverse justify-end',
    label && 'gap-1',
    className
  );

  return (
    <div
      className={wrapClasses}
      onClick={handleToggle}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      }}>
      <div className="flex-0 mb-auto flex">
        <CheckboxMark isChecked={checked} color={color} />
      </div>

      {label && (
        <span className={`text-sm font-normal leading-5 text-${colorLabel}`}>{label}</span>
      )}
    </div>
  );
};

export default CheckboxCommon;
